// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminBenchmarkPanel_panel__tONNo {
  position: fixed;
  top: 60px;
  right: 16px;
  width: 300px;
  max-height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  z-index: 1400;
  overflow: hidden;
}

.AdminBenchmarkPanel_header__i96CR {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f6;
  background: #f8fafc;
}

.AdminBenchmarkPanel_headerTitle__VVfsm {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.AdminBenchmarkPanel_headerSubtitle__VX8TU {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.AdminBenchmarkPanel_collapseBtn__3rUma {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0 4px;
}
.AdminBenchmarkPanel_collapseBtn__3rUma:hover {
  color: #1e293b;
}

.AdminBenchmarkPanel_tabs__CVLca {
  display: flex;
  gap: 4px;
  padding: 8px 12px 0;
  border-bottom: 1px solid #eef2f6;
  background: #fbfdff;
}

.AdminBenchmarkPanel_tab__ib-nP {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 8px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s, border-color 0.15s;
}
.AdminBenchmarkPanel_tab__ib-nP:hover {
  color: #1e293b;
}
.AdminBenchmarkPanel_tab--active__r-8l2 {
  color: #e8622c;
  border-bottom-color: #e8622c;
}

.AdminBenchmarkPanel_saveBtnFull__lyx7M {
  width: 100%;
  border: none;
  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 12px;
  cursor: pointer;
}
.AdminBenchmarkPanel_saveBtnFull__lyx7M:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);
}
.AdminBenchmarkPanel_saveBtnFull__lyx7M:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.AdminBenchmarkPanel_guestNote__Xixsd {
  padding: 10px 16px;
  border-bottom: 1px solid #eef2f6;
  background: #fbfdff;
  font-size: 11.5px;
  color: #94a3b8;
  line-height: 1.4;
}

.AdminBenchmarkPanel_body__exbd5 {
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 16px 16px;
  overflow-y: auto;
}

.AdminBenchmarkPanel_section__86c1A {
  padding: 12px 0;
  border-bottom: 1px dashed #eef2f6;
}
.AdminBenchmarkPanel_section__86c1A:last-child {
  border-bottom: none;
}

.AdminBenchmarkPanel_sectionHead__jv4xh {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.AdminBenchmarkPanel_sectionTitle__PXwkL {
  font-size: 12.5px;
  font-weight: 600;
  color: #334155;
}

.AdminBenchmarkPanel_sectionHint__vCTCs {
  font-size: 10.5px;
  color: #94a3b8;
  white-space: nowrap;
}

.AdminBenchmarkPanel_optionList__wtQrE {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.AdminBenchmarkPanel_optionRow__Hf\\+4g {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #475569;
  cursor: pointer;
}
.AdminBenchmarkPanel_optionRow__Hf\\+4g input {
  cursor: pointer;
  accent-color: #3b5bdb;
}

.AdminBenchmarkPanel_optionRowDisabled__UqNZ6 {
  opacity: 0.45;
  cursor: not-allowed;
}
.AdminBenchmarkPanel_optionRowDisabled__UqNZ6 input {
  cursor: not-allowed;
}

.AdminBenchmarkPanel_paletteList__54xDO {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
}

.AdminBenchmarkPanel_paletteRow__5JJEY {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #475569;
  cursor: pointer;
}
.AdminBenchmarkPanel_paletteRow__5JJEY input {
  cursor: pointer;
  accent-color: #3b5bdb;
}

.AdminBenchmarkPanel_paletteLabel__z8476 {
  min-width: 92px;
}

.AdminBenchmarkPanel_paletteSwatches__sP\\+XV {
  display: inline-flex;
  gap: 2px;
}

.AdminBenchmarkPanel_paletteSwatch__0z-84 {
  width: 12px;
  height: 12px;
  border-radius: 3px;
}

.AdminBenchmarkPanel_entityColorList__8mYjp {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
  border-top: 1px dashed #eef2f6;
}

.AdminBenchmarkPanel_entityColorRow__X-XEE {
  display: flex;
  align-items: center;
  gap: 8px;
}

.AdminBenchmarkPanel_colorInput__OIREh {
  width: 26px;
  height: 22px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
}

.AdminBenchmarkPanel_entityColorName__W0x9r {
  font-size: 12px;
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
}

.AdminBenchmarkPanel_entityColorReset__iJAs- {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 2px 4px;
}
.AdminBenchmarkPanel_entityColorReset__iJAs-:hover {
  color: #1e293b;
}

.AdminBenchmarkPanel_colorsHint__88Pad {
  font-size: 11.5px;
  color: #94a3b8;
  padding: 4px 0 8px;
}

.AdminBenchmarkPanel_resetColorsBtn__5sChS {
  margin-top: 6px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
}
.AdminBenchmarkPanel_resetColorsBtn__5sChS:hover {
  background: #eef2f6;
}

.AdminBenchmarkPanel_reopenTab__55jkh {
  position: fixed;
  top: 88px;
  right: 16px;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  background: #3b5bdb;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  transition: background 0.15s ease, transform 0.15s ease;
}
.AdminBenchmarkPanel_reopenTab__55jkh:hover {
  background: #324ec2;
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/AdminBenchmarkPanel/AdminBenchmarkPanel.module.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAPY;EAQZ,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAFF;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAHF;;AAMA;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,2CAAA;AAHF;AAKE;EACE,cAAA;AAHJ;AAME;EACE,cAAA;EACA,4BAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AALF;AAOE;EACE,8CAAA;AALJ;AAQE;EACE,YAAA;EACA,mBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAPF;;AAUA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,iCAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AARF;;AAWA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AARF;AAUE;EACE,eAAA;EACA,qBAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAVF;AAYE;EACE,eAAA;EACA,qBAAA;AAVJ;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,oBAAA;EACA,QAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,8BAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAXF;;AAcA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAXF;AAaE;EACE,cAAA;AAXJ;;AAeA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAZF;;AAeA;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAZF;AAcE;EACE,mBAAA;AAZJ;;AAgBA;EACE,eAAA;EACA,SAjSU;EAkSV,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,6CAAA;EACA,uDAAA;AAbF;AAeE;EACE,mBAAA;EACA,2BAAA;AAbJ","sourcesContent":["$panel-width: 300px;\n$panel-top: 88px;\n\n.panel {\n  position: fixed;\n  top: 60px;\n  right: 16px;\n  width: $panel-width;\n  max-height: calc(100vh - #{$panel-top});\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);\n  z-index: 1400;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #eef2f6;\n  background: #f8fafc;\n}\n\n.headerTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.headerSubtitle {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.collapseBtn {\n  border: none;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0 4px;\n\n  &:hover {\n    color: #1e293b;\n  }\n}\n\n.tabs {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px 0;\n  border-bottom: 1px solid #eef2f6;\n  background: #fbfdff;\n}\n\n.tab {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 8px;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.15s, border-color 0.15s;\n\n  &:hover {\n    color: #1e293b;\n  }\n\n  &--active {\n    color: #e8622c;\n    border-bottom-color: #e8622c;\n  }\n}\n\n.saveBtnFull {\n  width: 100%;\n  border: none;\n  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 700;\n  border-radius: 8px;\n  padding: 9px 12px;\n  margin-bottom: 12px;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.guestNote {\n  padding: 10px 16px;\n  border-bottom: 1px solid #eef2f6;\n  background: #fbfdff;\n  font-size: 11.5px;\n  color: #94a3b8;\n  line-height: 1.4;\n}\n\n.body {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 8px 16px 16px;\n  overflow-y: auto;\n}\n\n.section {\n  padding: 12px 0;\n  border-bottom: 1px dashed #eef2f6;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.sectionHead {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.sectionTitle {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.sectionHint {\n  font-size: 10.5px;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.optionList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.optionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  color: #475569;\n  cursor: pointer;\n\n  input {\n    cursor: pointer;\n    accent-color: #3b5bdb;\n  }\n}\n\n.optionRowDisabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n\n  input {\n    cursor: not-allowed;\n  }\n}\n\n.paletteList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.paletteRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  color: #475569;\n  cursor: pointer;\n\n  input {\n    cursor: pointer;\n    accent-color: #3b5bdb;\n  }\n}\n\n.paletteLabel {\n  min-width: 92px;\n}\n\n.paletteSwatches {\n  display: inline-flex;\n  gap: 2px;\n}\n\n.paletteSwatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n}\n\n.entityColorList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 0;\n  border-top: 1px dashed #eef2f6;\n}\n\n.entityColorRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.colorInput {\n  width: 26px;\n  height: 22px;\n  padding: 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 5px;\n  background: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.entityColorName {\n  font-size: 12px;\n  color: #475569;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.entityColorReset {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n  padding: 2px 4px;\n\n  &:hover {\n    color: #1e293b;\n  }\n}\n\n.colorsHint {\n  font-size: 11.5px;\n  color: #94a3b8;\n  padding: 4px 0 8px;\n}\n\n.resetColorsBtn {\n  margin-top: 6px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 6px 10px;\n  cursor: pointer;\n\n  &:hover {\n    background: #eef2f6;\n  }\n}\n\n.reopenTab {\n  position: fixed;\n  top: $panel-top;\n  right: 16px;\n  z-index: 1400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 1px solid #e2e8f0;\n  border-radius: 50%;\n  background: #3b5bdb;\n  color: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n  transition: background 0.15s ease, transform 0.15s ease;\n\n  &:hover {\n    background: #324ec2;\n    transform: translateY(-1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `AdminBenchmarkPanel_panel__tONNo`,
	"header": `AdminBenchmarkPanel_header__i96CR`,
	"headerTitle": `AdminBenchmarkPanel_headerTitle__VVfsm`,
	"headerSubtitle": `AdminBenchmarkPanel_headerSubtitle__VX8TU`,
	"collapseBtn": `AdminBenchmarkPanel_collapseBtn__3rUma`,
	"tabs": `AdminBenchmarkPanel_tabs__CVLca`,
	"tab": `AdminBenchmarkPanel_tab__ib-nP`,
	"tab--active": `AdminBenchmarkPanel_tab--active__r-8l2`,
	"saveBtnFull": `AdminBenchmarkPanel_saveBtnFull__lyx7M`,
	"guestNote": `AdminBenchmarkPanel_guestNote__Xixsd`,
	"body": `AdminBenchmarkPanel_body__exbd5`,
	"section": `AdminBenchmarkPanel_section__86c1A`,
	"sectionHead": `AdminBenchmarkPanel_sectionHead__jv4xh`,
	"sectionTitle": `AdminBenchmarkPanel_sectionTitle__PXwkL`,
	"sectionHint": `AdminBenchmarkPanel_sectionHint__vCTCs`,
	"optionList": `AdminBenchmarkPanel_optionList__wtQrE`,
	"optionRow": `AdminBenchmarkPanel_optionRow__Hf+4g`,
	"optionRowDisabled": `AdminBenchmarkPanel_optionRowDisabled__UqNZ6`,
	"paletteList": `AdminBenchmarkPanel_paletteList__54xDO`,
	"paletteRow": `AdminBenchmarkPanel_paletteRow__5JJEY`,
	"paletteLabel": `AdminBenchmarkPanel_paletteLabel__z8476`,
	"paletteSwatches": `AdminBenchmarkPanel_paletteSwatches__sP+XV`,
	"paletteSwatch": `AdminBenchmarkPanel_paletteSwatch__0z-84`,
	"entityColorList": `AdminBenchmarkPanel_entityColorList__8mYjp`,
	"entityColorRow": `AdminBenchmarkPanel_entityColorRow__X-XEE`,
	"colorInput": `AdminBenchmarkPanel_colorInput__OIREh`,
	"entityColorName": `AdminBenchmarkPanel_entityColorName__W0x9r`,
	"entityColorReset": `AdminBenchmarkPanel_entityColorReset__iJAs-`,
	"colorsHint": `AdminBenchmarkPanel_colorsHint__88Pad`,
	"resetColorsBtn": `AdminBenchmarkPanel_resetColorsBtn__5sChS`,
	"reopenTab": `AdminBenchmarkPanel_reopenTab__55jkh`
};
export default ___CSS_LOADER_EXPORT___;
